/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace nsSearchBarAdapter
 */
class nsSearchBarAdapter {

    constructor() {};

    adaptProductSearchResults(dataset) {
        let searchResults = [
            {
                "sectionTitle": "Products",
                "resultsList": dataset
            }
        ];
        return searchResults;
    };

    adaptLookAheadResults(products, market, lang, priceType, activeEvents = null) {
        let productArr = [];
        if (products) {
            for(let i = 0; i < products.length; i++) {
                products[i].setPriceAndPvFromType((typeof(priceType) === 'string' && priceType.length > 0) ? priceType : "WRTL", activeEvents);
                let item = {};
                const originalPrice = products[i].getOriginalPrice ? products[i].getOriginalPrice() : null;
                item.img = products[i].thumbnail;
                item.itemName = products[i].title;
                item.sku = products[i].sku;
                item.price = products[i].price;
                item.pv = products[i].pv;
                item.cv = products[i].cv;
                item.isExclusive = products[i].isExclusive || false;
                if (products[i].agelocme) {
                    item.itemName = products[i].agelocme.label;
                    item.agelocme = products[i].agelocme;
                }
                if (originalPrice) item.originalPrice = originalPrice
                productArr.push(item);
            }
        }
        return productArr;
    }

    adaptPopularProductsResults(dataset, market, lang) {
        let productArr = [];
        if (dataset) {
            dataset.forEach((productObj) => {
                let item = {};
                item.img = productObj.getMarketChild(market).getImageUrl();
                item.itemName = productObj.getLanguageChild(lang).getTitle();
                item.sku = productObj.getSku();
                productArr.push(item)
            })
        }
        return productArr;
    }
}

export default new nsSearchBarAdapter();
